export default "//yastatic.net/s3/distribution/pythia/frontend/_/4e765efa095381e487872d5281b98740.png";